import { getHeight, getSpacing } from '@cabonline/ui-shared';
import styled from '@emotion/styled';

export const StyledContent = styled.div<{
  hasCloseButton: boolean;
}>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: ${getHeight('modalContentMinHeight')};
`;

export const StyledIconWrap = styled.div<{ isDesktop: boolean }>`
  margin-bottom: ${getSpacing('xs')};
  height: ${(p) => (p.isDesktop ? '40px' : '32px')}
  width: ${(p) => (p.isDesktop ? '40px' : '32px')}
`;

export const StyledActions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: ${getSpacing('s')};
  margin-top: ${getSpacing('m')};
  button {
    min-width: 88px;
  }
  width: auto;
`;

export const StyledTitleWrapper = styled.div`
  outline: none;
`;
